import React from "react";
import { inject, observer } from "mobx-react";
import { Button, Input, Modal } from "antd";
import AuthorizedPhoneItem from './AuthorizedPhoneItem'
import EditItem from './EditItem'
import { users } from '@services/api';
import { alertPopup } from "@utils/popup";

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
export default class AuthorizedPhonesPopup extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
            name: '',
            phone: '',
            editId: null
        }
    }

    onClose = () => {
        const { popupStore: { togglePopup } } = this.props
        togglePopup(false)
    }

    toggleEdit = (id) => {
        this.setState({ editId: id })
    }

    handleInput = (e) => {
        const [type, field] = e.target.id.split("-")
        let value = e.target.value
        if (type === 'input') {
            if (field === 'phone') {
                value = value.replace(/[^0-9\.]/g, '')
            }
            this.setState({ [field]: value })
        }
    }

    submit = () => {
        const { user_id, getAuthorizedPhones } = this.props
        const { phone, name } = this.state

        const payload = {
            phone,
            name,
            user_id
        }
        
        users.addAuthorizedPhone(payload)
        .then(() => {
            getAuthorizedPhones()
            this.setState({ name: '', phone: '' })
            alertPopup({ type: 'success', title: 'עדכון בוצע בהצלחה', body: '' })
        })
        .catch((error) => {
            let { errorCode } = error.response.data            
            alertPopup({ type: 'error', title: this.errorMsgs[errorCode] || 'העדכון נכשל', body: '' })
        })
    }

    errorMsgs = {
        PHONE_EXIST: 'מספר הטלפון כבר קיים במערכת',
        INVALID_PHONE: 'מספר הטלפון לא תקין',
        OWN_NUMBER: 'המספר זהה למספר הסוכן'
    }

    render() {
        const { list, user_id,  getAuthorizedPhones} = this.props
        const { name, phone, editId } = this.state
        return (
            <>
                <Button onClick={() => this.props.popupStore.togglePopup('AuthorizedPhonesPopup')}>
                    מספרי טלפון מורשים
                </Button>
                <Modal
                    visible={this.props.popupStore.popupType === 'AuthorizedPhonesPopup'}
                    onCancel={this.onClose}
                    footer={false}
                    width="600px"
                >
                    <div style={{ ...style.body }}>
                        <h4>{"מספרים מורשים"}</h4>
                        <div style={{ ...style.list }}>
                            {Array.isArray(list) ?
                                list.map((item, idx) => {
                                    return editId === item.id ? (
                                        <EditItem
                                            key={idx.toString()}
                                            item={item}
                                            user_id={user_id}
                                            toggleEdit={this.toggleEdit}
                                            errorMsgs={this.errorMsgs}
                                            getAuthorizedPhones={getAuthorizedPhones}
                                        />
                                    ) : (
                                        <AuthorizedPhoneItem
                                            key={idx.toString()}
                                            item={item}
                                            user_id={user_id}
                                            toggleEdit={() => this.toggleEdit(item.id)}
                                            errorMsgs={this.errorMsgs}
                                            getAuthorizedPhones={getAuthorizedPhones}
                                        />
                                    ) 
                                }) : <h6 style={{ alignSelf: 'center' }}>אין מספרים מורשים</h6>
                            }
                        </div>
                        <h6 style={{ marginTop: '30px' }}>{"הוספה:"}</h6>
                        <div style={{ ...style.addNew }}>
                            <div style={{ ...style.input, marginLeft: '15px' }}>
                                <span style={{ marginLeft: '15px', width: '70px' }}>{"שם מלא"}</span>
                                <Input id="input-name" value={name} onChange={this.handleInput}/>
                            </div>
                            <div style={{ ...style.input, marginLeft: '15px' }}>
                                <span style={{ marginLeft: '15px' }}>{"טלפון"}</span>
                                <Input id="input-phone" value={phone} onChange={this.handleInput}/>
                            </div>
                            <Button onClick={this.submit} style={{ marginTop: '-5px' }}>{"הוסף"}</Button>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}

const style = {
    body: { display: 'flex', flexDirection: 'column', paddingInline: '15px', paddingTop: '30px' },
    list: { display: 'flex', flexDirection: 'column', alignItems: 'start', width: '100%' },
    listItem: { display: 'flex', justifyContent: 'space-between',  width: '170px', paddingTop: '10px' },
    addNew: { display: 'flex', alignItems: 'center', marginTop: '10px' },
    input: { display: 'flex', alignItems: 'center' }
}